import { render, staticRenderFns } from "./DashboardBackUp.vue?vue&type=template&id=1f73a0d5&"
import script from "./DashboardBackUp.vue?vue&type=script&lang=js&"
export * from "./DashboardBackUp.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBackUp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports